import jsPDF from "jspdf";

const generateTrainingPDF = (title, exercises) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(25);
    const titleWidth = doc.getTextWidth(title);
    doc.text(title, (pageWidth - titleWidth) / 2, 20);

    const fontSize = 25;
    doc.setFontSize(fontSize);
    let yPosition = 40;
    const lineHeight = 12;
    const gapBetweenExercises = 15;

    exercises.forEach((exercise) => {
        doc.setFont("helvetica", "bold");
        doc.text(`${exercise.category}`, 20, yPosition);
        yPosition += lineHeight;

        doc.setFont("helvetica", "normal");
        const wrappedDescription = doc.splitTextToSize(
            exercise.description,
            pageWidth - 40
        );

        wrappedDescription.forEach((line) => {
            doc.text(line, 20, yPosition);
            yPosition += lineHeight;

            if (yPosition > doc.internal.pageSize.getHeight() - 20) {
                doc.addPage();
                yPosition = 20;
            }
        });

        yPosition += gapBetweenExercises;

        if (yPosition > doc.internal.pageSize.getHeight() - 20) {
            doc.addPage();
            yPosition = 20;
        }
    });

    doc.save(`${title}.pdf`);
}

export default generateTrainingPDF;